import { JAVA_SVC } from "../config";
import { apiFetch } from "./httpClient";

export async function getAllCategories() {
  const URL = `/category`;

  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch categories.");
  }

  return data;
}

export async function getAllParentCategories(id) {
  const URL = `/category/parentcategory/${id}/asc`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch parent categories.");
  }

  return data;
}

export async function getCategoryById({ categoryName }) {
  const response = await apiFetch(`/category/${categoryName}`, {
    method: "GET",
    
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch categories.");
  }

  return data;
}

export async function getAllNullParentCategories() {
  const URL = `/category/parentcat`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch parent categories.");
  }

  return data;
}

export async function getAllChildCategories({categoryName}) {
  const URL = `/category/groupProjParentCategory/${categoryName}`;
  const response = await apiFetch(URL, {
    method: "GET",
    
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Could not fetch sub categories.");
  }

  return data;
}
